export const isVisibleItem = (areaKeys) => (_) => !_.displayArea || areaKeys.includes(_.displayArea.toLowerCase());
//# sourceMappingURL=isVisibleItem.js.map